// PrimeOak® Architectural Timber Panels — data (all imagery = labelled placeholders)

export const PANEL_INTRO = {
  eyebrow: "Timber Collection / Architectural Panels",
  title: "PrimeOak® Timber Panels",
  intro:
    "A collection of PrimeOak® timber panels, crafted from 100% American Northern Red Oak. Available across a considered range of profiles, grain selections, colour finishes, dimensions and thicknesses — composed to suit a tailored interior finish.",
};

export const GRAINS = [
  { slug: "rift-quartered", name: "Select Rift & Quartered Sawn", image: "/assets/panels/grains/rift-quartered.jpg" },
  { slug: "live-sawn", name: "Select Live Sawn", image: "/assets/panels/grains/live-sawn.jpg" },
  { slug: "light-character", name: "Light Character", image: "/assets/panels/grains/light-character.jpg" },
];

export const crossSection = (slug) => `/assets/panels/profiles/${slug}.jpg`;
export const sampleCard = (slug) => `/assets/panels/samples/${slug}-card.jpg`;
export const sampleDetail = (slug) => `/assets/panels/samples/${slug}-detail.jpg`;

export const FINISHES = [
  { name: "Armory", slug: "armory", hex: "#b67217" },
  { name: "Barn", slug: "barn", hex: "#9e621a" },
  { name: "Barrel", slug: "barrel", hex: "#9e4c0b" },
  { name: "Bristol", slug: "bristol", hex: "#945b26" },
  { name: "Burnished Bronze", slug: "burnished-bronze", hex: "#985111" },
  { name: "Burnt Copper", slug: "burnt-copper", hex: "#76390a" },
  { name: "Chairo", slug: "chairo", hex: "#a35a16" },
  { name: "Danbury", slug: "danbury", hex: "#a36c3c" },
  { name: "French Vanilla", slug: "french-vanilla", hex: "#b17737" },
  { name: "French White", slug: "french-white", hex: "#ac7e54" },
  { name: "Giniro", slug: "giniro", hex: "#a15f23" },
  { name: "Kuro", slug: "kuro", hex: "#423b34" },
  { name: "Limestone", slug: "limestone", hex: "#b1895d" },
  { name: "Mocha", slug: "mocha", hex: "#a16836" },
  { name: "Naked", slug: "naked", hex: "#af6915" },
  { name: "Natural", slug: "natural", hex: "#ab6e2d" },
  { name: "Pearl", slug: "pearl", hex: "#af6814" },
  { name: "Post", slug: "post", hex: "#855115" },
  { name: "Pure", slug: "pure", hex: "#b17939" },
  { name: "Tailor Taupe", slug: "tailor-taupe", hex: "#ae7235" },
  { name: "Tanners", slug: "tanners", hex: "#8d4e19" },
  { name: "Tawny", slug: "tawny", hex: "#9b4f09" },
  { name: "Waka", slug: "waka", hex: "#b08a61" },
  { name: "Windsor", slug: "windsor", hex: "#ab6315" },
  { name: "Winston", slug: "winston", hex: "#7f4e28" },
  { name: "Yaketa", slug: "yaketa", hex: "#895126" },
  { name: "Yoko", slug: "yoko", hex: "#74482c" },
];

export const finishImage = (slug) => `/assets/panels/finishes/${slug}.jpg`;

const milled = (slug, name, width) => ({
  slug,
  name,
  width,
  panelType: "PrimeOak® Milled Panel",
  dimensions: `${width} × 2745 / 3000 mm`,
  thickness: "13 mm / 19 mm",
  surface: "Profiled",
  joint: "Tongue & Groove",
  sides: "—",
});

export const PROFILES = [
  milled("linea-a", "Linea A", 294),
  milled("linea-b", "Linea B", 289),
  milled("linea-c", "Linea C", 280),
  milled("nori", "Nori", 300),
  milled("forma", "Forma", 305),
  milled("dune-a", "Dune A", 288),
  milled("modo", "Modo", 288),
  milled("corsa", "Corsa", 288),
  milled("krest", "Krest", 289),
  milled("dune-b", "Dune B", 300),
  milled("cairo", "Cairo", 294),
  milled("eterna", "Eterna", 296),
  {
    slug: "flat-fl14",
    name: "Flat – FL14",
    width: 1220,
    panelType: "PrimeOak® Flat Panel",
    dimensions: "1220 × 2440 / 2745 mm",
    thickness: "4 mm / 19 mm",
    surface: "Flat",
    joint: "—",
    sides: "One-sided / Two-sided",
  },
];

export const findProfile = (slug) => PROFILES.find((p) => p.slug === slug);

export const PANEL_DISCLAIMER =
  "Not all grains or finishes are available in every profile. Samples are for reference only. Natural variations in colour and grain are to be expected. Please confirm availability with House of David before ordering.";
